module.exports = __webpack_public_path__ + "img/k8s.74e86a7d.svg";